// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.application-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}
.application-container .side-menus {
  flex-grow: 1;
}

.app-header {
  font-size: var(--font-size-x-large);
  background-color: var(--panel-color-default);
  border-style: solid;
  border-color: white;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.header-button {
  background-color: var(--panel-color-default);
}

.side-menus {
  background-color: var(--panel-color-default);
  height: auto;
  min-height: 50em;
  align-items: left;
}

::ng-deep .mat-tooltip {
  font-size: 14px;
  white-space: pre-line;
}

mat-sidenav-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
mat-sidenav-container .side-menus {
  flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AACF;AACE;EACE,YAAA;AACJ;;AAGA;EACE,mCAAA;EACA,4CAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAAF;;AAGA;EACE,4CAAA;AAAF;;AAGA;EACE,4CAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,eAAA;EACA,qBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAAF;AAEE;EACE,YAAA;AAAJ","sourcesContent":[".application-container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow: hidden;\n\n  .side-menus {\n    flex-grow: 1;\n  }\n}\n\n.app-header {\n  font-size: var(--font-size-x-large);\n  background-color: var(--panel-color-default);\n  border-style: solid;\n  border-color: white;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.header-button {\n  background-color: var(--panel-color-default);\n}\n\n.side-menus {\n  background-color: var(--panel-color-default);\n  height: auto;\n  min-height: 50em;\n  align-items: left;\n}\n\n::ng-deep .mat-tooltip {\n  font-size: 14px;\n  white-space: pre-line;\n}\n\nmat-sidenav-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\n  .side-menus {\n    flex-grow: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
